export const FAQ_META = {
  title_zh: "什么是 i.S.i Group？| 马来西亚人寿保险代理团队",
  title_en: "What Is i.S.i Group? | Malaysia Life Insurance Agency Group",
  desc_zh:
    "了解 i.S.i Group（Infinite Sanguine Innovators）——立足马来西亚的人寿保险代理团队，由 Charles Lee 创立，专注保障规划、客户服务、保险教育、科技应用与专业保险事业发展。",
  desc_en:
    "Learn about i.S.i Group (Infinite Sanguine Innovators), a Malaysia-based life insurance agency group founded by Charles Lee, focused on protection, client service, technology and professional agency development.",
};

export const FAQ_SECTIONS = [
  {
    title: { en: "What is i.S.i Group?", zh: "什么是 i.S.i Group？" },
    blocks: [
      { t: "p", en: "i.S.i Group (Infinite Sanguine Innovators) is a Malaysia-based life insurance agency group founded by Charles Lee.", zh: "i.S.i Group，全名 Infinite Sanguine Innovators，是一个立足马来西亚的人寿保险代理团队，由 Charles Lee 创立。" },
      { t: "p", en: "The group focuses on protection-oriented financial planning, client servicing, insurance education, professional agency development and technology-enabled team building.", zh: "i.S.i Group 专注于保障规划、客户服务、保险教育、专业保险事业发展，以及运用科技提升团队经营效率。" },
      { t: "p", en: "At i.S.i Group, we believe insurance should not begin with selling a product. It should begin with understanding a person's needs, responsibilities and financial risks.", zh: "我们相信：保险的开始，不应该只是销售一份产品。真正的开始应该是先了解一个人的家庭、责任、收入以及可能面对的财务风险。" },
      { t: "p", en: "Our goal is simple: To make insurance easier to understand and help more people protect what matters to them.", zh: "我们的目标很简单：让保险变得更容易理解，让更多人懂得如何保障自己与重要的人。" },
    ],
  },
  {
    title: { en: "What does i.S.i stand for?", zh: "i.S.i 代表什么意思？" },
    blocks: [
      { t: "p", en: "i.S.i stands for Infinite Sanguine Innovators. The name represents three ideas that shape our culture:", zh: "i.S.i 代表：Infinite Sanguine Innovators" },
      {
        t: "list",
        items: [
          { en: "Infinite — We believe growth and learning should never stop.", zh: "Infinite｜无限 — 代表持续学习、持续成长以及不断突破。" },
          { en: "Sanguine — We believe in approaching challenges with optimism, confidence and positive energy.", zh: "Sanguine｜积极 — 代表以积极、正面的态度面对挑战与改变。" },
          { en: "Innovators — We believe the insurance industry should continue evolving through better systems, technology, education and customer experience.", zh: "Innovators｜创新者 — 代表我们相信保险行业可以通过科技、教育、系统以及更好的客户体验不断进步。" },
        ],
      },
      { t: "p", en: "Together, these ideas represent the kind of organisation we want to build: positive, progressive and continuously improving.", zh: "这三个词代表了 i.S.i Group 希望建立的文化：积极、专业、创新、不断进步。" },
    ],
  },
  {
    title: { en: "Who founded i.S.i Group?", zh: "谁创办了 i.S.i Group？" },
    blocks: [
      { t: "p", en: "i.S.i Group was founded by Charles Lee, a Malaysian life insurance agency leader with extensive experience in the life insurance industry.", zh: "i.S.i Group 由拥有丰富寿险行业经验的 Charles Lee 创立。" },
      { t: "p", en: "Throughout his career, Charles has been involved in insurance sales, agency development, recruitment, training, leadership and team building.", zh: "Charles 长期参与寿险销售、团队发展、人才招募、培训、领导以及保险事业经营。" },
      { t: "p", en: "After years of experience in the traditional agency environment, he founded i.S.i Group with a vision to build a more modern insurance agency platform centred around:", zh: "累积多年行业经验后，他创立 i.S.i Group，希望打造一个更加现代化的保险事业平台。我们的核心包括：" },
      { t: "list", items: [
        { en: "Protection", zh: "保障" }, { en: "Professionalism", zh: "专业" }, { en: "Client service", zh: "服务" },
        { en: "Education", zh: "教育" }, { en: "Technology", zh: "科技" }, { en: "Systems", zh: "系统" }, { en: "Leadership development", zh: "领导力" },
      ] },
      { t: "p", en: "The objective is not only to develop successful insurance advisers, but also to create professionals capable of building sustainable careers while serving clients responsibly.", zh: "我们的目标不仅是培养能够创造业绩的保险顾问，更希望培养能够长期经营事业、专业服务客户以及发展团队的人才。" },
    ],
  },
  {
    title: { en: "What does i.S.i Group do?", zh: "i.S.i Group 主要做什么？" },
    blocks: [
      { t: "p", en: "i.S.i Group focuses on two major areas:", zh: "我们的发展主要分成两个方向。" },
      { t: "h3", en: "1. Client Protection & Financial Planning", zh: "1. 客户保障与财务风险规划" },
      { t: "p", en: "Our advisers help individuals, families and business owners better understand their financial risks and protection needs. Depending on individual circumstances and eligibility, areas of discussion may include:", zh: "我们的顾问协助个人、家庭以及企业主了解自己可能面对的财务风险。根据不同客户的实际情况、需求以及投保资格，可讨论的范围包括：" },
      { t: "list", items: [
        { en: "Life protection", zh: "人寿保障" },
        { en: "Medical and hospitalisation coverage", zh: "医疗与住院保障" },
        { en: "Critical illness protection", zh: "严重疾病保障" },
        { en: "Income protection", zh: "收入保障" },
        { en: "Family protection", zh: "家庭保障" },
        { en: "Mortgage protection", zh: "房贷保障" },
        { en: "Business protection", zh: "企业保障" },
        { en: "Key person protection", zh: "Key Person 关键人物保障" },
        { en: "Legacy-related protection planning", zh: "财富与传承相关保障规划" },
        { en: "Existing policy reviews", zh: "现有保单检视" },
        { en: "Claims and policy servicing", zh: "理赔与保单服务" },
      ] },
      { t: "p", en: "Every client's circumstances are different. Therefore, insurance planning should begin with understanding the client's needs rather than simply recommending the same solution to everyone.", zh: "每个人的人生阶段、收入、家庭责任以及预算都不一样。因此，保障规划应该从了解需求开始，而不是把同样的方案推荐给每一个人。" },
      { t: "h3", en: "2. Insurance Agency & Career Development", zh: "2. 保险事业与人才发展" },
      { t: "p", en: "i.S.i Group also develops individuals who want to build a professional career in the life insurance industry. Our agency development system may include training in areas such as:", zh: "i.S.i Group 同时培养希望在寿险行业建立专业事业的人才。培训范围可包括：" },
      { t: "list", items: [
        { en: "Insurance knowledge", zh: "保险专业知识" },
        { en: "Protection needs analysis", zh: "保障需求分析" },
        { en: "Prospecting", zh: "客户开发" },
        { en: "Client communication", zh: "沟通技巧" },
        { en: "Appointment skills", zh: "Appointment 技巧" },
        { en: "Follow-up", zh: "Follow-up" },
        { en: "Personal branding", zh: "个人品牌" },
        { en: "Social media", zh: "Social Media" },
        { en: "Client servicing", zh: "客户服务" },
        { en: "Claims support", zh: "理赔协助" },
        { en: "Recruitment", zh: "招募" },
        { en: "Team building", zh: "团队经营" },
        { en: "Leadership", zh: "领导力" },
        { en: "Technology", zh: "科技应用" },
        { en: "AI-assisted workflows", zh: "AI 辅助工作流程" },
      ] },
      { t: "p", en: "Our objective is to help advisers become more systematic, professional and sustainable in building their careers.", zh: "我们希望让保险事业变得更加系统化、专业化以及可持续发展。" },
    ],
  },
  {
    title: { en: "What makes i.S.i Group different?", zh: "i.S.i Group 有什么不同？" },
    blocks: [
      { t: "p", en: "We believe the modern insurance industry requires more than traditional selling. Today's clients have access to more information than ever before. They want to understand:", zh: "我们相信今天的保险行业已经不能只依赖传统销售方式。现代客户会问：" },
      { t: "list", items: [
        { en: "Why do I need this protection?", zh: "为什么我需要这个保障？" },
        { en: "What exactly am I paying for?", zh: "我的钱到底买到了什么？" },
        { en: "What happens when I need to make a claim?", zh: "真正需要理赔的时候怎么办？" },
        { en: "Is my current insurance still suitable for my family?", zh: "我现在拥有的保险还够吗？" },
      ] },
      { t: "p", en: "This is why i.S.i Group emphasises several important principles.", zh: "所以 i.S.i Group 特别重视几个原则。" },
      { t: "h3", en: "Protection Before Products", zh: "保障先于产品" },
      { t: "p", en: "Insurance exists primarily to transfer financial risk. Before discussing a particular solution, we believe an adviser should first understand:", zh: "保险最核心的功能之一，是帮助个人和家庭转移无法独自承担的财务风险。因此，在讨论产品以前，我们希望先了解：" },
      { t: "list", items: [
        { en: "What risks does the client face?", zh: "你面对什么风险？" },
        { en: "Who depends on the client's income?", zh: "谁依靠你的收入生活？" },
        { en: "What financial commitments exist?", zh: "你有什么贷款与家庭责任？" },
        { en: "What protection does the client already have?", zh: "你目前已经拥有什么保障？" },
        { en: "Where are the potential protection gaps?", zh: "还有什么保障缺口？" },
      ] },
      { t: "p", en: "Only after understanding these questions should suitable options be explored.", zh: "了解这些问题之后，再讨论适合的解决方案。" },
      { t: "h3", en: "Education Before Decision", zh: "先了解，再决定" },
      { t: "p", en: "Insurance can sometimes appear complicated. Terms such as these can be difficult for consumers to understand:", zh: "保险里面有很多消费者未必熟悉的词语，例如：" },
      { t: "list", items: [
        { en: "Deductible", zh: "Deductible" }, { en: "Co-insurance", zh: "Co-insurance" },
        { en: "Critical illness", zh: "Critical Illness" }, { en: "Investment-linked insurance", zh: "Investment-linked 投资连结保险" },
        { en: "Medical limits", zh: "Medical Limit 医疗限额" }, { en: "Exclusions", zh: "Exclusion 除外责任" },
        { en: "Underwriting", zh: "Underwriting 核保" }, { en: "Nomination", zh: "Nomination 受益人指定" },
      ] },
      { t: "p", en: "Our goal is to make these concepts easier to understand so clients can make more informed decisions.", zh: "i.S.i Group 希望把复杂的保险知识变得简单，让客户在充分了解以后，再作出自己的决定。" },
      { t: "h3", en: "Service Beyond the Sale", zh: "服务不应该在成交后结束" },
      { t: "p", en: "Buying insurance is only the beginning of the relationship. Over time, clients may need assistance with:", zh: "购买保险只是关系的开始。随着人生阶段改变，客户可能需要：" },
      { t: "list", items: [
        { en: "Policy servicing", zh: "保单服务" },
        { en: "Updating personal information", zh: "更新个人资料" },
        { en: "Understanding benefits", zh: "了解保障内容" },
        { en: "Policy reviews", zh: "保单检视" },
        { en: "Medical card questions", zh: "医疗卡咨询" },
        { en: "Claims procedures", zh: "理赔协助" },
        { en: "Family protection changes", zh: "调整家庭保障规划" },
      ] },
      { t: "p", en: "We believe long-term servicing is an important part of professional insurance practice.", zh: "因此，我们重视长期客户服务。" },
      { t: "h3", en: "Technology-Enabled Insurance Agency", zh: "科技化保险团队" },
      { t: "p", en: "Technology is changing how insurance advisers operate. i.S.i Group believes technology and artificial intelligence can help advisers become more efficient in areas such as:", zh: "我们相信科技与 AI 可以帮助保险顾问提升效率。应用范围可以包括：" },
      { t: "list", items: [
        { en: "Client management", zh: "客户管理" }, { en: "Prospect management", zh: "Prospect Management" },
        { en: "Training", zh: "培训" }, { en: "Content creation", zh: "内容制作" },
        { en: "Follow-up", zh: "Follow-up" }, { en: "Productivity", zh: "生产力" }, { en: "Team operations", zh: "团队运营" },
      ] },
      { t: "p", en: "Technology should support professional advisers — not replace responsible human advice.", zh: "但是科技的角色应该是辅助专业顾问，而不是取代人与人之间真正的沟通、判断与责任。" },
    ],
  },
  {
    title: { en: "Who does i.S.i Group serve?", zh: "谁适合找 i.S.i Group？" },
    blocks: [
      { t: "p", en: "We work with people at different stages of life. This may include:", zh: "我们服务不同人生阶段的人，包括：" },
      { t: "list", items: [
        { en: "Young Professionals — People beginning their careers who want to understand medical and basic protection.", zh: "年轻上班族 — 开始了解医疗与基本保障。" },
        { en: "Families — Parents who want to protect their income, children and long-term family responsibilities.", zh: "家庭与父母 — 希望保障家庭收入、孩子与未来责任。" },
        { en: "Property Owners — Individuals who want to understand mortgage-related protection and the financial risks associated with housing loans.", zh: "房屋贷款者 — 希望了解房贷与家庭财务风险。" },
        { en: "Business Owners — Entrepreneurs who want to understand key person risk, business continuity and succession-related protection.", zh: "企业主 — 关注 Key Person、Business Continuity 与企业传承。" },
        { en: "High-Net-Worth Families — Families who want to explore protection and legacy-related financial planning.", zh: "高净值家庭 — 希望进一步了解家庭保障与财富传承相关规划。" },
        { en: "Existing Policyholders — People who already own insurance but want to better understand what they currently have.", zh: "已经拥有保险的人 — 希望重新了解自己到底拥有什么保障。" },
      ] },
    ],
  },
  {
    title: { en: "Can i.S.i Group review my existing insurance policies?", zh: "已经有保险，还可以找 i.S.i Group 吗？" },
    blocks: [
      { t: "p", en: "Yes. You may request an insurance policy review even if you already own insurance. The purpose of a policy review is to help you better understand:", zh: "可以。你可以进行现有保单检视。我们可以协助你进一步了解：" },
      { t: "list", items: [
        { en: "What coverage you currently have", zh: "目前有什么保障" },
        { en: "Medical benefits", zh: "医疗保障多少" },
        { en: "Life protection", zh: "人寿保障多少" },
        { en: "Critical illness protection", zh: "重疾保障多少" },
        { en: "Existing limits", zh: "现有保障限额" },
        { en: "Deductibles or co-insurance", zh: "是否存在 Deductible / Co-insurance" },
        { en: "Important exclusions or conditions", zh: "重要的除外责任或条件" },
        { en: "Whether your protection still reflects your current circumstances", zh: "目前的保障是否仍然符合现在的人生阶段" },
      ] },
      { t: "p", en: "A review does not automatically mean you need another policy. Sometimes the most important first step is simply understanding what you already have.", zh: "进行 Policy Review 并不代表一定需要购买新的保险。很多时候，第一步只是：先真正看懂自己已经拥有的保障。" },
      { t: "p", en: "Official confirmation and interpretation of an existing policy remains subject to the issuing insurer and the policy contract.", zh: "对于现有保单的最终条款解释以及保障确认，仍应以原保险公司的正式保单合约为准。" },
    ],
  },
  {
    title: { en: "Does i.S.i Group provide claims assistance?", zh: "i.S.i Group 可以协助理赔吗？" },
    blocks: [
      { t: "p", en: "Our advisers may assist clients in understanding the general claims process and the documents commonly required. The final assessment and approval of any claim remains the responsibility of the insurer according to the applicable policy terms.", zh: "我们的顾问可以协助客户了解一般理赔流程以及通常需要准备的文件。最终是否符合赔偿条件以及理赔金额，仍由相关保险公司根据正式保单条款进行审核及决定。" },
      { t: "p", en: "We believe an insurance adviser's responsibility should not end after a policy is issued.", zh: "我们相信：保险顾问的责任，不应该在保单签发以后就结束。" },
    ],
  },
  {
    title: { en: "Can I join i.S.i Group as an insurance adviser?", zh: "可以加入 i.S.i Group 成为保险顾问吗？" },
    blocks: [
      { t: "p", en: "i.S.i Group welcomes conversations with individuals interested in exploring a professional career in the life insurance industry. You do not necessarily need previous insurance or sales experience.", zh: "可以进一步与我们的团队了解这个事业机会。即使过去没有保险或销售经验，也可以先了解保险事业。" },
      { t: "p", en: "However, building a professional insurance career requires:", zh: "但是要长期经营这个行业，需要：" },
      { t: "list", items: [
        { en: "Discipline", zh: "纪律" }, { en: "Continuous learning", zh: "学习能力" },
        { en: "Communication", zh: "沟通能力" }, { en: "Consistency", zh: "持续行动" },
        { en: "Professional ethics", zh: "专业操守" }, { en: "Responsibility toward clients", zh: "对客户负责" },
      ] },
      { t: "p", en: "Applicants must also satisfy applicable regulatory, examination, contractual and insurer requirements.", zh: "申请者同时必须符合相关监管、考试、保险公司及合约要求。" },
    ],
  },
  {
    title: { en: "Where is i.S.i Group based?", zh: "i.S.i Group 在哪里？" },
    blocks: [
      { t: "p", en: "i.S.i Group is based in Malaysia and works with clients and agency partners in different parts of the country.", zh: "i.S.i Group 立足于马来西亚，并与不同地区的客户以及保险事业伙伴合作。" },
      { t: "p", en: "For consultations, policy reviews, claims-related assistance or career enquiries, please contact i.S.i Group through our official communication channels.", zh: "如果你希望进行：保障咨询、Medical Card 咨询、家庭保障、企业保障、保单检视、理赔咨询、保险事业咨询，欢迎通过 i.S.i Group 官方渠道联系我们。" },
    ],
  },
  {
    title: { en: "Frequently Asked Questions", zh: "常见问题 FAQ" },
    blocks: [
      { t: "qa", items: [
        {
          q: { en: "Is i.S.i Group an insurance company?", zh: "i.S.i Group 是保险公司吗？" },
          a: { en: "i.S.i Group is an insurance agency group rather than an insurance company itself. Insurance policies are issued and underwritten by the relevant licensed insurer, subject to its terms and approval.", zh: "i.S.i Group 是保险代理团队，并不是保险公司本身。保险产品由相关持牌保险公司承保及签发，并以保险公司的正式条款和核保结果为准。" },
        },
        {
          q: { en: "Can i.S.i Group help me choose insurance?", zh: "i.S.i Group 可以帮我选择保险吗？" },
          a: { en: "An authorised adviser can help you understand your needs and available options. Any recommendation should consider your circumstances, affordability, existing coverage and eligibility.", zh: "授权顾问可以协助您了解自身需求与可选方案。任何建议都会考虑您的实际情况、负担能力、现有保障以及投保资格。" },
        },
        {
          q: { en: "Can i.S.i Group help if I already have insurance?", zh: "已经有保险还可以找 i.S.i Group 吗？" },
          a: { en: "Yes. You may request a policy review to better understand your existing protection.", zh: "可以。你可以进行 Policy Review，重新了解自己目前拥有的保障。" },
        },
        {
          q: { en: "Does i.S.i Group only serve wealthy clients?", zh: "i.S.i Group 只服务高收入客户吗？" },
          a: { en: "No. Protection planning can be relevant at different income levels and life stages. The appropriate amount and type of coverage depends on individual needs and affordability.", zh: "不是。不同收入以及不同人生阶段的人，都可能面对医疗、疾病、收入中断及家庭责任等风险。保障规划应根据个人实际需求及负担能力进行。" },
        },
        {
          q: { en: "Can business owners consult i.S.i Group?", zh: "企业老板可以找 i.S.i Group 吗？" },
          a: { en: "Yes. Business owners may discuss areas such as personal protection, key person risk, business continuity and succession-related protection.", zh: "可以。企业主可进一步了解个人保障、Key Person Risk、Business Continuity 以及企业传承相关保障规划。" },
        },
        {
          q: { en: "How do I contact i.S.i Group?", zh: "如何联系 i.S.i Group？" },
          a: { en: "Contact us through our official website or authorised i.S.i Group communication channels and tell us what assistance you require.", zh: "可以通过 i.S.i Group 官方网站或官方联络渠道联系我们，并告诉团队你需要哪方面的协助。" },
        },
      ] },
    ],
  },
];

export const FAQ_CLOSING = {
  h_en: "Start With Understanding",
  h_zh: "从「了解」开始",
  p1_en: 'You do not have to start by asking: "Which insurance should I buy?"',
  p1_zh: "你不一定需要先问：「我应该买什么保险？」",
  p2_en: 'Start with a better question: "What financial risks do I need to protect?"',
  p2_zh: "你可以先问一个更重要的问题：「我真正需要保障的风险是什么？」",
  p3_en: "At i.S.i Group, we believe better understanding leads to better financial protection decisions.",
  p3_zh: "我们相信：真正了解以后，才能作出更适合自己的决定。",
  motto_en: "Understand first. Protect what matters.",
  motto_zh: "Understand First. Protect What Matters.",
  brand: "i.S.i Group",
  brandSub: "Infinite Sanguine Innovators",
};

export const FAQ_DISCLAIMER = {
  h: "Disclaimer｜免责声明",
  en: "The information provided on this page is for general educational purposes only and does not constitute personalised financial, legal, tax or medical advice. Insurance eligibility, benefits, exclusions, underwriting, premiums, charges and claims are subject to the terms and conditions of the relevant insurer and policy.",
  zh: "本页面内容仅作为一般保险教育及资讯用途，并不构成针对个人的财务、法律、税务或医疗建议。实际投保资格、保障利益、除外责任、核保、保费、费用及理赔均以相关保险公司的正式产品文件及保单条款为准。",
};
